import { IControllerBase, IDomServices } from 'global/interfaces/controller.interface';
import { DomServices } from './DomServices';
import { InputServices } from './InputsServices';
export default class ControllerBase<T extends Record<keyof T, string> = Record<string, string>> implements IControllerBase<T> {
	readonly $element: HTMLElement;
	readonly $references: Record<keyof T, HTMLElement>;
	readonly ignoredReferences: string[];
	readonly includedReferences: string[];
	readonly disableReferenceCollection: boolean;
	/** See {@link DomServices} */
	readonly domUtils: IDomServices<T>;
	/** See {@link InputServices} */
	readonly inputUtils: InputServices;

	constructor(element: HTMLElement, ignoredReferences?: string[], includedReferences?: string[], disableReferenceCollection?: boolean) {
		this.$element = element;
		this.ignoredReferences = ignoredReferences || [];
		this.includedReferences = includedReferences || [];
		this.disableReferenceCollection = disableReferenceCollection || false;

		if (!this.disableReferenceCollection) {
			const references = DomServices.collectReferences<T>(this.$element, this.ignoredReferences, this.includedReferences);
			if (references && Object.keys(references).length > 0) {
				this.$references = references as Record<keyof T, HTMLElement>;
			} else {
				this.$references = {} as Record<keyof T, HTMLElement>;
			}
		}

		this.domUtils = new DomServices(this.$element, this.$references);
		this.inputUtils = new InputServices();
	}

	dispatchCustomEvent<T>(
		name: string,
		detail: T,
		bubbles: boolean = false,
		dispatchOnWindow: boolean = false,
		dispatchOnSpecificElement?: HTMLElement,
	): void {
		const customEvent = new CustomEvent(name, { detail: detail, bubbles: bubbles });
		if (true === dispatchOnWindow) {
			window.dispatchEvent(customEvent);
		} else if (dispatchOnSpecificElement) {
			dispatchOnSpecificElement.dispatchEvent(customEvent);
		} else {
			this.$element.dispatchEvent(customEvent);
		}
	}
}
